/**
 * Helper function to allow for easily creating valid `React.ChangeEvent`s
 * @param targetNode the target of the event (any HTML element/node)
 */
export function makeChangeEvent<T extends EventTarget>(targetNode: T) {
  const nativeEvent = new Event('change');

  const ev: React.ChangeEvent<T> = {
    bubbles: true,
    cancelable: false,
    currentTarget: targetNode,
    defaultPrevented: false,
    eventPhase: 3,
    isDefaultPrevented: () => nativeEvent.defaultPrevented,
    isPropagationStopped: () => false,
    isTrusted: true,
    nativeEvent,
    target: targetNode,
    timeStamp: nativeEvent.timeStamp,
    type: 'change',
    preventDefault: nativeEvent.preventDefault,
    stopPropagation: nativeEvent.stopPropagation,
    persist: () => {
      //
    },
  };

  return ev;
}
